<template>
    <div class="vrm-installation-avatar">
        <img :src="avatar" alt="installation avatar" @error="handleImageError" />
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-installation-avatar')
export default class VrmInstallationAvatar extends Vue {
    @Prop()
    installation;

    get avatar() {
        const inst = this.installation;
        if (inst && inst.avatar_url) {
            return inst.avatar_url;
        } else {
            return '/img/installation-avatar/thumb-default.png';
        }
    }

    handleImageError(event) {
        event.target.src = '/img/installation-avatar/thumb-default.png';
    }
}
</script>
